import { useEffect, useState } from "react";

/**
 * Seiten, die nicht zur App gehören, sondern vom Server kommen: die
 * Angebotsseite des Kunden, Widerruf, AGB, Kündigung.
 *
 * Der Service Worker der App fängt jede Navigation auf dieser Domain ab. Die
 * Ausnahmen stehen in `vite.config.ts` (`navigateFallbackDenylist`) — aber ein
 * Browser mit einem ÄLTEREN Service Worker kennt sie nicht und zeigt die App
 * statt der Seite (28.09.2026: der Vertragslink landete auf „Heute").
 *
 * Kommt diese Komponente zum Zug, war es genau das: sie meldet den alten
 * Service Worker ab und lädt die Seite neu — dann antwortet der Server. Einmal
 * je Sitzung, damit nichts im Kreis lädt.
 */
export const SERVER_PFADE = ["/angebot", "/widerruf", "/agb", "/kuendigen", "/public"];

export default function ServerSeite() {
  const [versucht, setVersucht] = useState(false);
  useEffect(() => {
    const merker = "sw-abgemeldet:" + location.pathname;
    let schonMal = false;
    try { schonMal = sessionStorage.getItem(merker) === "1"; } catch { /* privat */ }
    if (schonMal) { setVersucht(true); return; }
    try { sessionStorage.setItem(merker, "1"); } catch { /* privat */ }
    const neu = () => location.reload();
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations()
        .then(regs => Promise.all(regs.map(r => r.unregister())))
        .finally(neu);
    } else {
      neu();
    }
  }, []);
  return (
    <div style={{ padding: 32, fontFamily: "system-ui, sans-serif", color: "var(--vg-text)" }}>
      {versucht ? (
        <>Die Seite konnte nicht geladen werden. <a href={location.href}>Noch einmal versuchen</a></>
      ) : "Einen Moment …"}
    </div>
  );
}
